/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'TodoItem'>;
const hooks = useModelQueries(schema, 'TodoItem');

export const useAggregateTodoItem: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountTodoItem: Hooks['useCount'] = hooks.useCount;
export const useCreateTodoItem: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyTodoItem: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnTodoItem: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteTodoItem: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyTodoItem: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsTodoItem: Hooks['useExists'] = hooks.useExists;
export const useFindFirstTodoItem: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyTodoItem: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueTodoItem: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByTodoItem: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyTodoItem: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateTodoItem: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountTodoItem: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstTodoItem: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyTodoItem: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueTodoItem: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByTodoItem: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyTodoItem: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateTodoItem: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyTodoItem: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnTodoItem: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertTodoItem: Hooks['useUpsert'] = hooks.useUpsert;
